<template>
  <PopUpMessageDialog
    :open="open"
    :title="$t('movedToAnotherDeviceDialog.title')"
    :messages="messages"
    @close="close"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PopUpMessageDialog from './PopUpMessageDialog.vue'
import { addUserSetting, filterMovedToAnotherDeviceMessages } from '@/services/user-settings'
import type { MovedToAnotherDeviceMessage } from '@/types/user'
import { NAMESPACES } from '@/store/types'
import { USER_GETTERS, USER_ACTIONS } from '@/store/user'

export default defineComponent({
  name: 'MovedToAnotherDeviceDialog',
  components: { PopUpMessageDialog },
  data() {
    return {
      open: false,
      movedToAnotherDeviceMessage: null as MovedToAnotherDeviceMessage | null
    }
  },
  mounted() {
    this.setMovedToAnotherDeviceMessage()
  },
  watch: {
    movedToAnotherDeviceMessages() {
      this.setMovedToAnotherDeviceMessage()
    }
  },
  computed: {
    messages() {
      const movedToAnotherDeviceMessages = []
      if (this.movedToAnotherDeviceMessage) {
        movedToAnotherDeviceMessages[0] = this.$t('movedToAnotherDeviceDialog.messagePartOne', {
          connectedDeviceSerial: this.movedToAnotherDeviceMessage.connectedDeviceSerial,
          smartBridgeSerial: this.movedToAnotherDeviceMessage.smartBridgeSerial
        })
        movedToAnotherDeviceMessages[1] = this.$t('movedToAnotherDeviceDialog.messagePartTwo')
      }
      return movedToAnotherDeviceMessages
    },
    movedToAnotherDeviceMessages(): MovedToAnotherDeviceMessage[] {
      return this.$store.getters[
        `${NAMESPACES.USER}/${USER_GETTERS.GET_MOVED_TO_ANOTHER_DEVICE_MESSAGES}`
      ]
    }
  },
  methods: {
    close() {
      this.removeMovedToAnotherDeviceMessage(this.movedToAnotherDeviceMessage)
      this.movedToAnotherDeviceMessage = null
      this.open = false
    },
    removeMovedToAnotherDeviceMessage(
      movedToAnotherDeviceMessage: MovedToAnotherDeviceMessage | null
    ) {
      const movedToAnotherDeviceMessages = filterMovedToAnotherDeviceMessages(
        this.movedToAnotherDeviceMessages,
        movedToAnotherDeviceMessage
      )
      const setting = addUserSetting({ movedToAnotherDeviceMessages })
      this.$store.dispatch(`${NAMESPACES.USER}/${USER_ACTIONS.UPDATE_SETTINGS}`, setting)

      try {
        this.$api.patchUserSettings(setting)
      } catch {
        // close modal
      }
    },
    setMovedToAnotherDeviceMessage() {
      if (this.movedToAnotherDeviceMessages?.length && !this.movedToAnotherDeviceMessage) {
        this.movedToAnotherDeviceMessage = this.movedToAnotherDeviceMessages[0]
        this.open = true
      }
    }
  }
})
</script>
